import axios from "../../../../../../api/axiosInstance";
import {
  FetchProductStoreCategoriesRequest,
  FetchProductStoreCategoriesResponse,
} from "./types";

export const fetchProductStoreCategories = async (
  params: FetchProductStoreCategoriesRequest,
  signal?: AbortSignal,
): Promise<FetchProductStoreCategoriesResponse> => {
  const response = await axios.get<FetchProductStoreCategoriesResponse>(
    "/api/private/product-store/categories",
    { params, signal },
  );
  return response.data;
};
